/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import EditIcon from '@mui/icons-material/Edit';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store/UploadManual';

interface Props {
    handleUploadDialogClick: Function
    selectedManual: any
    UpdateEditManualData: Function
}
class EditManual extends React.Component<Props>{
    handleEditClick = async () => {
        this.props.handleUploadDialogClick(true);
        await this.props.UpdateEditManualData(this.props.selectedManual);
    };
    render() {
        return (
            <div>
                <EditIcon className="editColor" onClick={this.handleEditClick} style={{ cursor: 'pointer' }} />
            </div>
        );
    }
}
const mapStateToProps = (state: any) => ({
    selectedManual: state.viewManual.selectedManual
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps, mapDispatchtoProps
)
    (EditManual);
